import { Image } from 'react-bootstrap';
import { isMobile } from 'react-device-detect';

function Portfolio() {
  return (
    <>
      <div className="px-4 py-5 my-5 text-center">
        <div className="col-lg-12 mb-4">
          <h2>&#92;&#92; PORTFOLIO</h2>
          <p className="lead mb-4"> Explore my works and ideas </p>

          <div className="row">
            {/* {items.map((item, i) => ( */}
            <div className="col md-6 lg-6 d-flex align-items-center justify-content-center flex-column">
              <Image src="/TOC-TN.png" height={isMobile ? 200 : 400} width={isMobile ? 300 : 600}></Image>
              <div>
                <p className="lead">&#92;&#92; <a href="https://tos-twek.onrender.com/">TOC Noord-Holland</a></p>
                <p className="lead ">
                  A website made with React, Bootstrap and ExpressJS. <br /> A simple design strategy and a clear
                  layout, alongside a strong backend.
                </p>
              </div>
            </div>
            <div className="col md-6 lg-6 d-flex align-items-center justify-content-center flex-column">
              <Image src="/MM.png" height={isMobile ? 200 : 400} width={isMobile ? 300 : 600}></Image>
              <div>
                <p className="lead">&#92;&#92; Maïra Meagher</p>
                <p className="lead ">
                  A modern website with a custom mobile view.
                </p>
              </div>
            </div>
            <div className="col md-6 lg-6 d-flex align-items-center justify-content-center flex-column">
              <Image src="/HMO.png" height={isMobile ? 200 : 400} width={isMobile ? 300 : 600}></Image>
              <div>
                <p className="lead">&#92;&#92; <a href="https://musical-octo-guacamole-x3a2.onrender.com">Hear Me Outt</a></p>
                <p className="lead ">
                  A frontend demo for a startup. Has a job board and walkthrough.
                </p>
              </div>
            </div>
            <div className="col md-6 lg-6 d-flex align-items-center justify-content-center flex-column">
              <Image src="/QSE.png" height={isMobile ? 200 : 400} width={isMobile ? 300 : 600}></Image>
              <div>
                <p className="lead">&#92;&#92; <a href="https://www.queersexedcc.com/">Queer Sex Ed</a></p>
                <p className="lead ">
                  Full Stack Web app with a React frontend and a Java Spring Boot backend. Has downloadable Zines, blogs and admin.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>{' '}
    </>
  );
}
export default Portfolio;
